import React, { useEffect } from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
const Booklist = () => {
  useEffect(() => {
    document.title =
      "Booklist - Mar Gregorios Memorial Hr. Sec. School, Bokaro";
  }, []);
  return (
    <>
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Academic</li>
          <li>Booklist</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Booklist</h1>
            </div>
          </div>
          <div className="row">
            {/* <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/prep.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Prep</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/pre-nur.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Pre-Nursury</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/nur.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Nursury</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div> */}
            <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/BOOK_LIST_1.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Class I</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/BOOK_LIST_2.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Class II</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/BOOK_LIST_3.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Class III</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/BOOK_LIST_4.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Class IV</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/BOOK_LIST_5.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Class V</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/BOOK_LIST_6.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Class VI</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/BOOK_LIST_7.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Class VII</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/BOOK_LIST_8.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Class VIII</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/BOOK_LIST_9.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Class IX</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/BOOK_LIST_10.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Class X</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/BOOK_LIST_11.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Class XI</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/BOOK_LIST_12.pdf"
                target="_blank"
              >
                <div className="sample-blk">
                  <p>Class XII</p>
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Booklist;
